export default {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC'
};